import React from 'react';
import {Box, Typography} from '@mui/material';
import PriorityIndicator from './PriorityIndicator';

const PRIORITY_VALUES = ['High', 'Medium', 'Low'];

function UnsetPriorityMark() {
    return (
        <Typography
            component="span"
            variant="caption"
            fontWeight={600}
            color="text.secondary"
            aria-label="Priority not set"
            sx={{lineHeight: 1.2, userSelect: 'none', fontStyle: 'italic'}}
        >
            N/A
        </Typography>
    );
}

/**
 * Gap list priority cell (read-only): unset shows "Unknown"; otherwise High/Medium/Low indicator.
 * Does not reuse PriorityIndicator for unset — that normalizes null to Medium.
 * Editing belongs on the Gap detail page (CM/admin).
 */
export default function GapPriorityCell({priority}) {
    const normalized = PRIORITY_VALUES.includes(priority) ? priority : '';

    return (
        <Box sx={{display: 'flex', pt: 0.15, minWidth: 0}}>
            {normalized
                ? (
                    <PriorityIndicator
                        priority={normalized}
                        showLabel={false}
                        sx={{height: 18, width: 20, flexShrink: 0}}
                    />
                )
                : <UnsetPriorityMark/>}
        </Box>
    );
}
